import { render, staticRenderFns } from "./TableDownload.vue?vue&type=template&id=1b01f5dc"
import script from "./TableDownload.vue?vue&type=script&lang=js"
export * from "./TableDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports